import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useAuth } from 'context/authContext'
import DotsLoading from 'components/loadings/dotsLoading'
import posthog from 'posthog-js'
import { navigateTo } from 'utilities/navigation'

// Entry point for the admin-panel "impersonate" button: a superuser mints a
// short-lived JWT for a member and opens this URL. We start from a clean
// localStorage (no leftover profile/query state from whoever last used this
// browser) and hard-redirect so every consumer of auth state (axios
// interceptor, ProtectedRoute, PostHog identity) reliably picks up the new
// token, matching how logout()/401-handling already force a full reload.
export default function Impersonate() {
    const [searchParams] = useSearchParams()
    const { login } = useAuth()
    const [error, setError] = useState(false)

    useEffect(() => {
        const token = searchParams.get('token')
        if (!token) {
            setError(true)
            return
        }
        window.localStorage.clear()
        // Tag every event in an impersonated (support/admin) session as a
        // super-property so these sessions can be excluded from product funnels
        // and don't pollute a real member's timeline.
        posthog.register({ is_impersonated: true })
        posthog.capture('impersonate_session_started')
        login({ token })
        navigateTo('/auth/profile')
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    if (error) {
        return (
            <div className="w-full h-screen flex items-center justify-center text-center px-6">
                <p>لینک ورود نامعتبر است.</p>
            </div>
        )
    }

    return (
        <div className="w-full h-screen flex items-center justify-center">
            <DotsLoading />
        </div>
    )
}
